<template>
<el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline jiaoyan" label-width="90px" size="mini">
    <el-drawer title="签收" @close="closeDialog"  direction="ltr" size="50%" :close-on-click-modal="false"  :wrapper-closable="false"   :visible="qianshouWHFlag">
      <div style="padding:12px" class="inpBox">
        <el-form-item label="运单编号:" prop="payee"  >
          <span>{{goodform.wayNo}}</span>
        </el-form-item>
        <el-form-item label="订单号:"  >
          <span>{{goodform.orderNo?goodform.orderNo:'-'}}</span>
        </el-form-item>
        <el-form-item label="创建人:"   >
          <span>{{goodform.createUser}}</span>
        </el-form-item>
        <br>
        <el-form-item label="结算客户:" prop="payee"  >
          <el-select  v-model="goodform.payee" v-if="jskhFlag&&!goodform.isSG" filterable placeholder="请选择" @change="jiesuanChange">
            <el-option v-for="item in kehuList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
          </el-select>
          <span v-else>{{goodform.payee}}</span>
        </el-form-item>
        <el-form-item label="项目名称:" prop="projectType"   >
          <el-select  v-model="goodform.projectType" filterable placeholder="请选择">
            <el-option v-for="item in XMlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="业务类型:" prop="wayBusinessType"   >
          <el-select  v-model="goodform.wayBusinessType"  v-if="!goodform.isSG"  placeholder="请选择">
            <el-option v-for="item in YWLXlist" :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
          </el-select>
          <span v-else>{{goodform.wayBusinessTypeName}}</span>
        </el-form-item>
        <el-form-item label="销售合同:"  >
          <el-input  placeholder="" class="disabled" :readonly="true"    maxlength="50" v-model="goodform.salesContract"  ></el-input>
        </el-form-item>
        <el-button type="text"  @click="xuanzeHT" style="margin-top: 8px;">选择</el-button>
        <el-form-item label="外部单号:"  >
          <el-input  placeholder=""    maxlength="50" v-model="goodform.externalOrderNumber"  ></el-input>
        </el-form-item>
        <!-- <el-form-item label="业务部门:" prop="insuranceInfo"   >
          <div style="width:150px">{{goodform.businessUnit}}</div>
        </el-form-item> -->
        <el-form-item label="业务人员:" prop="insuranceInfo"  v-if="isZhuanbao" >
          <div style="width:150px">{{goodform.businessUser}}</div>
        </el-form-item>
        <el-form-item label="业务人员:" prop="businessUserId" v-if="!isZhuanbao">
          <div v-if="ywyhFlag">{{goodform.businessUser}}</div>
          <el-select  v-else v-model="goodform.businessUserId" filterable placeholder="请选择" @change="yonghuChange">
            <el-option v-for="item in yonghuList" :label="item.userName" :value="item.userCode" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <hr>
        <div class="addressBox">
            <h4 class="title">
              <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>收发信息</span>
            </h4>
        </div>
        <div>
          <el-form-item    label="发货人:" prop="deliverPerson" v-if="goodform.deliverAddressId">
            <div style="width:80px">{{goodform.deliverPerson}}</div>
          </el-form-item>
          <el-form-item label="电话:" prop="deliverPhone" v-if="goodform.deliverAddressId">
            <div style="width:80px">{{goodform.deliverPhone}}</div>
          </el-form-item>
          <el-form-item   label="始发流向:" v-if="goodform.deliverAddressId">
            <div style="width:200px">{{goodform.startDirection}}</div>
          </el-form-item>
          <el-form-item  label="发货地址:" prop="deliverAddress" class="diqu1" v-if="goodform.deliverAddressId">
            <div style="min-width:150px">{{goodform.deliverAddress}}</div>
          </el-form-item>
        </div>
        <div>
          <el-form-item  label="收货人:" prop="receivingPerson" v-if="goodform.receivingAddressId">
            <div style="width:80px">{{goodform.receivingPerson}}</div>
          </el-form-item>
          <el-form-item label="电话:" prop="receivingPhone" v-if="goodform.receivingAddressId">
            <div style="width:80px">{{goodform.receivingPhone}}</div>
          </el-form-item>
          <el-form-item label="目的流向:" prop="receivingCompany" v-if="goodform.receivingAddressId">
            <div style="width:200px">{{goodform.endDirection}}</div>
          </el-form-item>
          <el-form-item  label="收货地址:" prop="receivingAddress" class="diqu1" v-if="goodform.receivingAddressId">
            <div style="min-width:150px">{{goodform.receivingAddress}}</div>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="是否往返:"  prop="arriveDepartFlag" :rules="[{required: true, message: '请选择往返',  trigger: 'change', },]">
            <span>{{goodform.arriveDepartFlag}}</span>
          </el-form-item>
          <el-form-item label="共计:">
            <span class="red">{{goodform.kilometres?goodform.kilometres:'-'}}</span>公里
          </el-form-item>
        </div>
        <hr>
        <!-- 添加货物外库 -->
       <div class="addressBox">
            <h4 class="title">
              <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>货物信息</span>
            </h4>
        </div>
        <el-form-item  label="货物类型:" >
            <div style="width:80px">{{goodform.productTypeName}}</div>
        </el-form-item>
        <el-form-item  label="计量单位:" >
            <div style="width:80px">{{goodform.measuringUnit}}</div>
        </el-form-item>
        <el-form-item  label="重量(吨):">
            <div style="width:80px">{{goodform.dispatchWeightT?goodform.dispatchWeightT:'-'}}</div>
        </el-form-item>
        <el-form-item  label="数量(件):">
            <div style="width:80px">{{goodform.dispatchNumber?goodform.dispatchNumber:'-'}}</div>
        </el-form-item>
        <el-form-item  label="体积(方):">
            <div style="width:80px">{{goodform.dispatchVolumn?goodform.dispatchVolumn:'-'}}</div>
        </el-form-item>
        <el-form-item  label="货物备注:">
            <div style="width:80px">{{goodform.productRemark?goodform.productRemark:'-'}}</div>
        </el-form-item>
        <div style="text-align: right; margin-top: -20px;padding-right: 20px;" v-if="goodform.goodsList.length>0">
          <i class="el-icon-arrow-down icon" v-if="isZhankai" @click="isZhankai=!isZhankai"></i>
          <i class="el-icon-arrow-up icon" v-if="!isZhankai"  @click="isZhankai=!isZhankai"></i>
        </div>
        <div style="padding:0 16px 16px 16px;" v-if="isZhankai&&goodform.goodsList.length>0">
        <el-table height="300px" size="mini" ref="tabref" :data="goodform.goodsList" style="width:100%" border center>
          <el-table-column type="index"  label="序号" width="60"></el-table-column>
          <el-table-column :show-overflow-tooltip="true"  prop="customerName"
            label="货权客户" min-width="180" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="cargoBarcode" label="捆包号"
            min-width="180" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量(吨)"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="number" label="数量(件)"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="volumn" label="体积(方)"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="productName" label="品名"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="model" label="材质"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="cargoLocation" label="货位"
              min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="contractNumber" label="合同号"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="agreementNumber" label="合约号"
            min-width="120" :formatter="formatterRowEmpty"></el-table-column>
        </el-table>
      </div>
      <div class="addressBox" style="margin-top:20px">
        <h4 class="title">
           <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>结算信息</span>
        </h4>
        <shouruQS :goodform="goodform"  v-if="!isZhuanbao"></shouruQS>
        <shouruWayZB :goodform="goodform" :isqianshou="true"  v-if="isZhuanbao"></shouruWayZB>
      </div>
      <div class="addressBox" style="margin-top:20px">
        <h4 class="title">
          <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>运费信息</span>
        </h4>
        <el-form-item label="承运商:" prop="generalCarrier" class="width1" :rules="[{ required: true, message: '请选择承运商', trigger: 'blur' }]" >
          {{goodform.generalCarrier}}
        </el-form-item>
        <el-form-item label="推送网货:" prop="onlineFreightFlag" v-if="goodform.onlineFlag==1&&goodform.generalCarrier">
            <span>{{goodform.onlineFreightFlag==1?'是':'否'}}</span>
          </el-form-item>
        <el-form-item label="服务费计算:" prop="reverseCountFlag" v-if="goodform.generalCarrier"  label-width="110px">
         <span>{{goodform.reverseCountFlag==1?'反算':'正算'}}</span>
        </el-form-item>
        <el-form-item label="需求车长:"   >
          <el-select  v-model="goodform.needLength" filterable placeholder="请选择">
            <el-option v-for="item in CClist" :label="item.name+'米'" :value="item.name+'米'" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-table :data="[{}]"  ref="table"  bordersize="mini" class="tableBox" style="" max-height="500px"  center border>
          <el-table-column label="车牌号" min-width="120">
            <template slot="header" >
              <div><span class="red">*</span>车牌号</div>
            </template>
            <template >
              <div>
                <el-form-item label=""   class="table_error" >
                  {{goodform.plateNumber}}
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="车牌颜色" min-width="120">
            <template >
              <div>
                <el-form-item label=""    class="table_error" >
                  {{goodform.licensePlateColorName}}
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="能源类型" min-width="120">
            <template >
              <div>
                <el-form-item label=""    class="table_error" >
                  {{goodform.energyTypeName}}
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="司机" min-width="120">
            <template slot="header" >
              <div><span class="red">*</span>司机</div>
            </template>
            <template >
              <div>
                <el-form-item label=""   class="table_error" >
                  {{goodform.driverName}}
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="联系电话" min-width="120">
            <template slot="header" >
              <div><span class="red">*</span>联系电话</div>
            </template>
            <template >
              <div>
                <el-form-item label=""  class="table_error"  >
                  {{goodform.driverPhone}}
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="身份证号" min-width="120">
            <template >
              <div>
                <el-form-item label=""  class="table_error"  >
                  {{goodform.idNumber}}
                </el-form-item>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <zhichu2QS :goodform="goodform" ></zhichu2QS>
      </div>
      </div>
      <el-drawer title="" size="98%" @close="closeDialog"   class="rightDrawer"  :wrapper-closable="false"
      :modal-append-to-body="false" :modal="false"  :visible="qianshouWHFlag">
        <div  style="padding:12px">
        <div v-if="goodform.auditStatus==1">
          <div style="">
            <h4 style="margin-left:16px;color:#0c46a2">装车</h4>
            <div style="padding-left:20px">
              <el-form-item label="装车量:" label-width="70px"   >
                <div class="width1">{{goodform.truckload?goodform.truckload:'-'}}{{goodform.measuringUnit}}</div>
              </el-form-item>
              <el-form-item label="装车时间:"  >
                <div class="width1">{{goodform.actualLoadingTime|dateFormat}}</div>
              </el-form-item>
            </div>
            <div v-if="ZCimgList.length>0">
              <div class="imgBox">
                <el-image
                  v-for="(item,index) in ZCimgList" :src="item.url" :key="index"
                  :preview-src-list="getSrcList(index,ZCimgList)">
                </el-image>
              </div>
              <div style=" font-size: 12px;"><span style="margin:0 46px 0 30px;"><span style="color:#999">上传人：</span>{{ZCimgList[0].createUser}}</span><span><span style="color:#999">上传时间：</span>{{ZCimgList[0].createTime|dateFormat}} </span></div>
            </div>
          </div>
          <div style="">
            <h4 style="margin-left:16px;color:#0c46a2">卸车</h4>
            <div style="padding-left:20px">
              <el-form-item label="卸车量:" label-width="70px"  >
                <div class="width1">{{goodform.unloadings?goodform.unloadings:'-'}}{{goodform.measuringUnit}}</div>
              </el-form-item>
              <el-form-item label="卸车时间:"  >
                <div class="width1">{{goodform.actualUnloadingTime|dateFormat}}</div>
              </el-form-item>
            </div>
            <div v-if="XCimgList.length>0">
              <div class="imgBox">
                <el-image
                  v-for="(item,index) in XCimgList" :src="item.url" :key="index"
                  :preview-src-list="getSrcList(index,XCimgList)">
                </el-image>
              </div>
              <div style=" font-size: 12px;"><span style="margin:0 46px 0 30px;"><span style="color:#999">上传人：</span>{{XCimgList[0].createUser}}</span><span><span style="color:#999">上传时间：</span>{{XCimgList[0].createTime|dateFormat}} </span></div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="addressBox" v-if="goodform.wayState>=2">
            <h4 class="title">
              <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>装车</span>
            </h4>
            <el-form-item label="装车量:"  prop="truckload" class="danweiBox width1 jiage" >
              <el-input  placeholder="" v-number-input.float="3"  @blur="zcFn"  maxlength="8"  v-model="goodform.truckload" key="1" v-if="goodform.measuringUnit!='件'"></el-input>
              <el-input  placeholder="" v-number-input.float="0"  @blur="zcFn" maxlength="8"  v-model="goodform.truckload" key="2" v-if="goodform.measuringUnit=='件'"></el-input>
              <span class="danwei">{{goodform.measuringUnit}}</span>
            </el-form-item>
            <el-form-item label="装车时间:" prop="actualLoadingTime">
                  <el-date-picker  v-model="goodform.actualLoadingTime"  format="yyyy-MM-dd HH:mm:ss"  value-format="timestamp"
                    type="datetime"></el-date-picker>
            </el-form-item>
            <uploadImgs :imgList.sync='ZCimgList' :max=10 @remove="remove"></uploadImgs>
            <div style="margin-bottom:20px; font-size: 12px;" v-if="ZCimgList.length>0">
              <span style="margin: 10px 50px 10px 10px;">上传人：{{ZCimgList[0].createUser}}</span>
              <span>上传时间：{{ZCimgList[0].createTime|dateFormat}} </span></div>
          </div>
          <div class="addressBox" v-if="goodform.wayState>=3">
            <h4 class="title">
              <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>卸车</span>
            </h4>
            <el-form-item label="卸车量:"  prop="unloadings" class="danweiBox width1 jiage">
              <el-input  placeholder="" v-number-input.float="3" @blur="xcFn"  maxlength="8"  v-model="goodform.unloadings" key="1" v-if="goodform.measuringUnit!='件'"></el-input>
              <el-input  placeholder="" v-number-input.float="0" @blur="xcFn"  maxlength="8"  v-model="goodform.unloadings" key="2" v-if="goodform.measuringUnit=='件'"></el-input>
              <span class="danwei">{{goodform.measuringUnit}}</span>
            </el-form-item>
            <el-form-item label="卸车时间:" prop="actualUnloadingTime">
                  <el-date-picker  v-model="goodform.actualUnloadingTime"  format="yyyy-MM-dd HH:mm:ss"  value-format="timestamp"
                    type="datetime" @change="actualUnloadingTimeFn"></el-date-picker>
            </el-form-item>
            <div style="margin:0 0 10px 15px; font-size: 12px;">*回单</div>
            <uploadImgs :imgList.sync='XCimgList' :max=10 @remove="remove"></uploadImgs>
            <div style="margin-bottom:20px; font-size: 12px;"  v-if="XCimgList.length>0">
              <span style="margin: 10px 50px 10px 10px;">上传人：{{XCimgList[0].createUser}}</span>
              <span>上传时间：{{XCimgList[0].createTime|dateFormat}} </span></div>
          </div>
        </div>
        <div class="addressBox" style="margin-top:20px">
          <h4 class="title">
            <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>签收</span>
          </h4>
          <el-form-item label="签收状态:" prop="signedState"  class="width1" >
            <el-select  v-model="goodform.signedState"  placeholder="请选择">
              <el-option  label="正常签收" :value="0" ></el-option>
              <el-option  label="异常签收" :value="1" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item  >
            <el-input  placeholder="备注"    maxlength="50" v-model="goodform.signRemark"  ></el-input>
          </el-form-item>
          <el-form-item label="结算量:"  class="danweiBox width1 jiage" >
            <el-input  placeholder="" v-number-input.float="3" @blur="jsFn"  maxlength="8"  v-model="goodform.liquidatedAmount" key="1" v-if="goodform.measuringUnit!='件'"></el-input>
            <el-input  placeholder="" v-number-input.float="0" @blur="jsFn"  maxlength="8"  v-model="goodform.liquidatedAmount" key="2" v-if="goodform.measuringUnit=='件'"></el-input>
            <span class="danwei">{{goodform.measuringUnit}}</span>
          </el-form-item>
          <el-form-item label="签收时间:" prop="actualSigningTime">
                <el-date-picker  v-model="goodform.actualSigningTime"  format="yyyy-MM-dd HH:mm:ss"  value-format="timestamp"
                  type="datetime" @change="actualSigningTimeFn" :readonly="true"></el-date-picker>
          </el-form-item>
          <!-- <uploadImgs :imgList.sync='QSimgList' :max=10 @remove="remove"></uploadImgs>
          <div style="margin-bottom:20px; font-size: 14px;" v-if="QSimgList.length>0">
            <span style="margin: 10px 50px 10px 10px;">上传人：{{QSimgList[0].createUser}}</span>
            <span>上传时间：{{QSimgList[0].createTime|dateFormat}} </span></div> -->
        </div>

        <div class="footerBtn">
          <el-button  @click="closeDialog"  >取消</el-button>
          <el-button  type="primary"  @click="savePDFn()">提 交</el-button>
        </div>
        </div>
      </el-drawer>
  </el-drawer>
  <!-- 关联合同 -->
  <guanlianhetong :goodform="goodform" v-if="GLHTflag" :GLHTflag.sync='GLHTflag'></guanlianhetong>
</el-form>
</template>

<script>
import uploadImgs from '@/views/newTMS/publicFiles/uploadImgs.vue'
import guanlianhetong from '@/views/newTMS/publicFiles/wayAndOrder/guanlianhetong.vue'
import shouruQS from '@/views/newTMS/publicFiles/wayAndOrder/shouruQS.vue'
import shouruWayZB from '@/views/newTMS/publicFiles/wayAndOrder/shouruWayZB.vue'
import zhichu2QS from '@/views/newTMS/publicFiles/wayAndOrder/zhichu2QS.vue'
import { getDictionaryDetailList, findCustomerInfoList, signForWay, getWaynfo, queryWayImg, insertWayImg, delWayImg } from '@/api/newTMS'
import { selectTMSTenantListByCustom, getDepartmentUsers } from '@/api/newCrm'
import { cVLlist } from '@/api/vgs-driver2.0'
import { formatterRowEmpty, dateFormatUtil } from '@/utils/util'
export default {
  name: 'addEditWay',
  components: {
    guanlianhetong, shouruQS, uploadImgs, zhichu2QS, shouruWayZB
  },
  props: {
    qianshouWHFlag: {
      type: Boolean,
      default: false
    },
    glhwFlag: {
      type: Boolean,
      default: false
    },
    wayBusinessId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      formatterRowEmpty: formatterRowEmpty,
      goodform: {
        goodsList: [],
        measuringUnit: '吨',
        wayState: 1,

        incomePattern: '0',
        makeTicketYn: '是',
        ticketSystemYn: '否',
        revenueValuation: '0'
      },
      dateFormatUtil: dateFormatUtil,
      ZCimgList: [],
      XCimgList: [],
      QSimgList: [],
      rules: {
        projectType: [
          { required: true, message: '请选择项目名称', trigger: 'blur' }
        ],
        payee: [
          { required: true, message: '请选择结算客户', trigger: 'blur' }
        ],
        wayBusinessType: [
          { required: true, message: '请选择业务类型', trigger: 'blur' }
        ],
        productType: [
          { required: true, message: '请选择货物类型', trigger: 'blur' }
        ],
        allWeight: [
          { required: true, message: '请输入货量', trigger: 'blur' }
        ],
        arrivalTime: [
          { required: true, message: '请选择要求到达时间', trigger: 'blur' }
        ],
        payer: [
          { required: true, message: '请输入车队长名称', trigger: 'blur' }
        ],
        payerTaxId: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        businessUserId: [
          { required: true, message: '请选择业务人员', trigger: 'blur' }
        ],
        incomeUnitPrice: [
          { required: true, message: '请输入收入单价', trigger: 'blur' }
        ],
        incomeAmount: [
          { required: true, message: '请输入收入金额', trigger: 'blur' }
        ],
        expenditurePattern: [
          { required: true, message: '请选择支出方式', trigger: 'blur' }
        ],
        freightPricingType: [
          { required: true, message: '请选择运费计价', trigger: 'blur' }
        ],
        freightUnitPrice: [
          { required: true, message: '请输入运费单价', trigger: 'blur' }
        ],
        allFreightAmount: [
          { required: true, message: '请输入运费金额', trigger: 'blur' }
        ],
        serviceRate: [
          { required: true, message: '请输入服务费率', trigger: 'blur' }
        ],
        serviceCharge: [
          { required: true, message: '请输入服务费', trigger: 'blur' }
        ],
        freightTaxRate: [
          { required: true, message: '请输入运费税率', trigger: 'blur' }
        ],
        truckload: [
          { required: true, message: '请输入装车量', trigger: 'blur' }
        ],
        unloadings: [
          { required: true, message: '请输入卸车量', trigger: 'blur' }
        ],
        liquidatedAmount: [
          { required: true, message: '请输入结算量', trigger: 'blur' }
        ],
        actualLoadingTime: [
          { required: true, message: '请选择装车时间', trigger: 'blur' }
        ],
        actualUnloadingTime: [
          { required: true, message: '请选择卸车时间', trigger: 'blur' }
        ],
        actualSigningTime: [
          { required: true, message: '请选择签收时间', trigger: 'blur' }
        ]
      },
      kehuList: [], // 结算客户
      YWLXlist: [], // 业务类型
      fileArr: [],
      GLHTflag: false, // 关联合同
      tWayBusiness: {}, // 运单业务字段
      delImgIds: [],
      deleteAttachmentsIds: [],
      yonghuList: [],
      ywyhFlag: false, // 客户身上是否有业务用户
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      elTags: ['需要架子', '需要棉被'],
      tagArr: [],
      isZhankai: false,
      jskhFlag: true, // 结算客户是否可修改
      CClist: [],
      isZhuanbao: null,
      XMlist: []
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    getDictionaryDetailList({ dictionaryType: 'business_type' }).then(res => { this.YWLXlist = res })
    getDictionaryDetailList({ dictionaryType: 'project_type' }).then(res => { this.XMlist = res })

    cVLlist().then(res => { this.CClist = res })
    getDepartmentUsers({ subOrgCode: localStorage.getItem('orgSubCode'), bussinessUserFlag: 1 }).then(res => { this.yonghuList = res })
    if (this.wayBusinessId) {
      getWaynfo({ wayBusinessId: this.wayBusinessId }).then(res => {
        this.goodform = res.tWay
        if (res.tOrderBusiness) {
          this.isZhuanbao = res.tOrderBusiness.orderSource == 1
        } else {
          this.isZhuanbao = false
        }
        this.$set(this.goodform, 'liquidatedAmount', this.goodform.unloadings)
        this.$set(this.goodform, 'actualSigningTime', new Date().getTime())

        queryWayImg({ wayNo: this.goodform.wayNo }).then(res => {
          res.loadingImgs.forEach(item => {
            this.ZCimgList.push({ status: 'ready', url: item.fileUrlOSS, id: item.id, createUser: item.createUserName, createTime: item.createTime })
          })
          res.unloadImgs.forEach(item => {
            this.XCimgList.push({ status: 'ready', url: item.fileUrlOSS, id: item.id, createUser: item.createUserName, createTime: item.createTime })
          })
        })

        if (this.goodform.pickupTimeStart) {
          this.$set(this.goodform, 'pickupTime', [this.goodform.pickupTimeStart, this.goodform.pickupTimeEnd])
        }

        this.$set(this.goodform, 'wayBusinessType', res.tWay.wayBusinessType.toString())
        this.$set(this.goodform, 'payee', res.tWayBusiness.payee)
        this.$set(this.goodform, 'payeeTaxId', res.tWayBusiness.payeeTaxId)
        this.$set(this.goodform, 'payeeCode', res.tWayBusiness.payeeCode)
        this.goodform.deleteWayGoodsRelIds = []
        if (res.tWay.productType) {
          this.$set(this.goodform, 'productType', res.tWay.productType.toString())
        }
        if (res.tWay.licensePlateColor) {
          this.$set(this.goodform, 'licensePlateColor', Number(res.tWay.licensePlateColor))
        }
        this.tWayBusiness = res.tWayBusiness

        // 附件回显
        res.wayAttachmentsList.forEach(item => {
          var filename = item.url.substring(item.url.lastIndexOf('/') + 1)
          this.fileArr.push({ status: 'ready', url: item.fileKeyUrl, id: item.id, name: filename })
        })
        // 收入相关
        this.$set(this.goodform, 'incomePattern', res.tWayBusiness.incomePattern.toString())
        this.$set(this.goodform, 'incomePatternName', res.tWayBusiness.incomePatternName)
        this.$set(this.goodform, 'revenueValuation', res.tWayBusiness.revenueValuation.toString())
        this.$set(this.goodform, 'revenueValuationName', res.tWayBusiness.revenueValuationName)
        this.$set(this.goodform, 'makeTicketYn', res.tWayBusiness.makeTicketYn)
        this.$set(this.goodform, 'ticketSystemYn', res.tWayBusiness.ticketSystemYn)
        if (res.tWayBusiness.incomeUnitPrice) {
          this.$set(this.goodform, 'incomeUnitPrice', res.tWayBusiness.incomeUnitPrice / 100)
        }
        if (res.tWayBusiness.incomeAmount) {
          this.$set(this.goodform, 'incomeAmount', res.tWayBusiness.incomeAmount / 100)
        }
        if (res.tWayBusiness.grossRevenue) {
          this.$set(this.goodform, 'grossRevenue', res.tWayBusiness.grossRevenue / 100)
        }
        if (res.tWayBusiness.revenueSurcharge) {
          this.$set(this.goodform, 'revenueSurcharge', res.tWayBusiness.revenueSurcharge / 100)
        }
        if (res.tWayBusiness.disburseSurcharge) {
          this.$set(this.goodform, 'disburseSurcharge', res.tWayBusiness.disburseSurcharge / 100)
        }
        this.$set(this.goodform, 'payee', res.tWayBusiness.payee)
        this.$set(this.goodform, 'payeeTaxId', res.tWayBusiness.payeeTaxId)
        this.$set(this.goodform, 'payeeCode', res.tWayBusiness.payeeCode)

        // 运力支出相关
        this.$set(this.goodform, 'generalCarrier', res.tWayBusiness.generalCarrier)
        this.$set(this.goodform, 'generalTaxId', res.tWayBusiness.generalTaxId)
        this.$set(this.goodform, 'collectionType', res.tWayBusiness.collectionType)
        this.$set(this.goodform, 'payer', res.tWayBusiness.payer)
        this.$set(this.goodform, 'payerTaxId', res.tWayBusiness.payerTaxId)
        this.$set(this.goodform, 'payerCode', res.tWayBusiness.payerCode)
        if (res.tWayBusiness.expenditurePattern || res.tWayBusiness.expenditurePattern === 0) {
          this.$set(this.goodform, 'expenditurePattern', res.tWayBusiness.expenditurePattern.toString())
          this.$set(this.goodform, 'expenditurePatternName', res.tWayBusiness.expenditurePatternName)
        }
        if (res.tWayBusiness.freightPricingType || res.tWayBusiness.freightPricingType === 0) {
          this.$set(this.goodform, 'freightPricingType', res.tWayBusiness.freightPricingType.toString())
          this.$set(this.goodform, 'freightPricingTypeName', res.tWayBusiness.freightPricingTypeName)
        }
        if (res.tWayBusiness.freightUnitPrice) {
          this.$set(this.goodform, 'freightUnitPrice', res.tWayBusiness.freightUnitPrice / 100)
        }
        if (res.tWayBusiness.freightAmount) {
          this.$set(this.goodform, 'allFreightAmount', res.tWayBusiness.freightAmount / 100)
        }
        this.$set(this.goodform, 'serviceRate', res.tWayBusiness.serviceRate)
        this.$set(this.goodform, 'serviceCharge', res.tWayBusiness.serviceCharge)
        this.$set(this.goodform, 'freightTaxRate', res.tWayBusiness.freightTaxRate)
        this.$set(this.goodform, 'freightRemark', res.tWayBusiness.freightRemark)
        this.$set(this.goodform, 'incomeRemark', res.tWayBusiness.incomeRemark)
        // 网货信息
        this.$set(this.goodform, 'onlineFreightFlag', res.tWayBusiness.onlineFreightFlag)
        // 货物信息
        this.$set(this.goodform, 'goodsList', res.goodslist)
        this.$set(this.goodform, 'allWeight', res.tWay.dispatchWeight)
        // 应收状态
        this.$set(this.goodform, 'ysSettlementStates', res.tWayBusiness.ysSettlementStates)
        if (res.goodslist.length > 0) {
          this.isZhankai = true
        }

        // 判断是不是首钢
        if (this.goodform.waySource == 2) {
          this.goodform.isSG = true
        } else {
          this.goodform.isSG = false
        }
        // 判断业务用户是否可选
        findCustomerInfoList({ businessType: 1 }).then(res => {
          selectTMSTenantListByCustom(res).then(res1 => {
            this.kehuList = res1
            let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
            if (json.length > 0) {
              if (json[0].businessUserCode) {
                this.ywyhFlag = true
              } else {
                this.ywyhFlag = false
              }
              this.jskhFlag = true
            } else {
              this.jskhFlag = false
            }
          })
        })
      })
    }
  },
  methods: {
    // 点击凭证放大
    getSrcList (index, arr) {
      let imgArr = arr.slice(index).concat(arr.slice(0, index))
      let urls = []
      imgArr.forEach(item => {
        urls.push(item.url)
      })
      return urls
    },
    zcFn () {
      // if (this.goodform.truckload > 40) {
      //   this.$alert('装车量超过标载40吨！', '系统提示')
      // }
    },
    xcFn () {
      if (this.goodform.unloadings > 40) {
        this.$alert('卸车量超过标载40吨！', '系统提示')
      }
    },
    jsFn () {
      if (this.goodform.truckload != this.goodform.unloadings) {
        let timer = setTimeout(() => {
          this.$alert('装车量和卸车量不一致！', '系统提示')
          clearTimeout(timer)
          timer = null
        })
      }
      if (this.goodform.unloadings != this.goodform.liquidatedAmount) {
        let timer = setTimeout(() => {
          this.$alert('结算量和卸车量不一致！', '系统提示')
          clearTimeout(timer)
          timer = null
        })
      }
      if (this.goodform.liquidatedAmount > 40) {
        let timer = setTimeout(() => {
          this.$alert('结算量量超过标载40吨！', '系统提示')
          clearTimeout(timer)
          timer = null
        })
      }
    },
    // 卸车时间
    actualUnloadingTimeFn (e) {
      var timestamp1 = new Date(e).getTime()
      let timestamp2 = new Date(this.goodform.actualLoadingTime).getTime()
      if (timestamp1 < timestamp2) {
        this.$alert('卸车时间需要大于装车时间', '系统提示')
        this.$set(this.goodform, 'actualUnloadingTime', null)
      }
    },
    // 签收时间
    actualSigningTimeFn (e) {
      var timestamp1 = new Date(e).getTime()
      let timestamp2 = new Date(this.goodform.actualUnloadingTime).getTime()
      if (timestamp1 < timestamp2) {
        this.$alert('签收时间需要大于卸车时间', '系统提示')
        this.$set(this.goodform, 'actualSigningTime', null)
      }
    },
    // 删除文件
    remove (file) {
      if (file.id) {
        this.delImgIds.push(file.id)
      }
    },
    // 计算货物重量
    getAllWeight () {
      this.allWeight = 0
      let allNumber = 0
      let allvolumn = 0
      this.goodform.goodsList.forEach(item => {
        if (item.weight) {
          this.allWeight = (this.allWeight * 1000 + item.weight * 1000) / 1000
        }
        if (item.number) {
          allNumber = (allNumber * 1000 + item.number * 1000) / 1000
        }
        if (item.volumn) {
          allvolumn = (allvolumn * 1000 + item.volumn * 1000) / 1000
        }
      })
      this.$set(this.goodform, 'dispatchWeightT', this.allWeight)
      this.$set(this.goodform, 'dispatchNumber', allNumber)
      this.$set(this.goodform, 'dispatchVolumn', allvolumn)
      this.orderWightFuzhi()
    },
    orderWightFuzhi () {
      if (this.goodform.measuringUnit == '吨') {
        this.$set(this.goodform, 'allWeight', this.goodform.dispatchWeightT)
      } else if (this.goodform.measuringUnit == '件') {
        this.$set(this.goodform, 'allWeight', this.goodform.dispatchNumber)
      } else if (this.goodform.measuringUnit == '方') {
        this.$set(this.goodform, 'allWeight', this.goodform.dispatchVolumn)
      }
      if (!this.goodform.id) { // 是新建的时候
        if (this.goodform.wayState == 4) {
          this.$set(this.goodform, 'liquidatedAmount', this.goodform.allWeight)
        }
      }
    },
    tagClick (item) {
      this.tagArr.push(item)
      this.tagArr = Array.from(new Set(this.tagArr))
      this.$set(this.goodform, 'remark', this.tagArr.toString())
    },
    remarkFn () {
      if (!this.goodform.remark) {
        this.tagArr = []
      }
    },
    // 选择用户
    yonghuChange (e) {
      let json = this.yonghuList.filter(item => item.userCode == e)
      this.$set(this.goodform, 'businessUser', json[0].userName)
    },
    savePDFn () {
      if (this.goodform.truckload > 40) {
        this.$confirm('装车量超过标载40吨！是否继续？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          this.saveFn()
        }).catch(() => {

        })
      } else {
        this.saveFn()
      }
    },
    saveFn () {
      if (this.ZCimgList.length == 0) {
        this.$alert('请选择装车凭证', '系统提示')
        return false
      }
      if (this.XCimgList.length == 0 && this.goodform.wayState >= 3) {
        this.$alert('请选择卸车凭证', '系统提示')
        return false
      }
      if (Number(this.goodform.liquidatedAmount) === 0 && this.goodform.wayState > 3) {
        this.$alert('结算量不能为0', '系统提示')
        return false
      }
      if (this.goodform.wayState == 4) { // 签收的时候默认签收状态为正常签收
        this.goodform.signedState = 1
      }
      let yewuleixingJson = this.YWLXlist.filter(item => item.itemNo == this.goodform.wayBusinessType)
      if (yewuleixingJson.length > 0) {
        this.goodform.wayBusinessTypeName = yewuleixingJson[0].showName
      } else {
        this.$set(this.goodform, 'wayBusinessType', null)
      }
      this.$refs.goodform.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (this.goodform.pickupTime) {
            this.goodform.pickupTimeStart = this.goodform.pickupTime[0]
            this.goodform.pickupTimeEnd = this.goodform.pickupTime[1]
          }
          let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
          if (json.length > 0) {
            this.goodform.payeeTaxId = json[0].customerTaxId
            this.goodform.payeeCode = json[0].tenantCode
          }
          if (this.goodform.collectionType == 2) { // 司机
            this.$set(this.goodform, 'payer', this.goodform.driverName)
            this.$set(this.goodform, 'payerTaxId', this.goodform.idNumber)
            this.goodform.payerCode = ''
          }
          // 赋值调度量
          this.$set(this.goodform, 'dispatchWeight', this.goodform.allWeight)
          // 运费总额赋值
          this.$set(this.goodform, 'freightAmount', this.goodform.allFreightAmount)
          // 组装数据
          let data = {}
          data.tWay = this.goodform

          data.goodslist = []// 修改只传新加的值
          this.goodform.goodsList.forEach(item => {
            if (!item.wayGoodsRelId) {
              data.goodslist.push(item)
            }
          })
          data.deleteWayGoodsRelIds = this.goodform.deleteWayGoodsRelIds
          data.deleteAttachmentsIds = this.deleteAttachmentsIds

          data.payeeCode = this.goodform.settlementCustomersCode
          data.payerCode = this.goodform.generalCode
          console.log(this.goodform)
          data.tWayBusiness = this.tWayBusiness// 把业务实体整个赋值
          // 收入相关
          data.tWayBusiness.payee = this.goodform.payee
          data.tWayBusiness.payeeTaxId = this.goodform.payeeTaxId
          data.tWayBusiness.payeeCode = this.goodform.payeeCode
          data.tWayBusiness.incomePattern = this.goodform.incomePattern
          data.tWayBusiness.revenueValuation = this.goodform.revenueValuation
          data.tWayBusiness.incomePatternName = this.goodform.incomePatternName
          data.tWayBusiness.revenueValuationName = this.goodform.revenueValuationName
          data.tWayBusiness.makeTicketYn = this.goodform.makeTicketYn
          data.tWayBusiness.ticketSystemYn = this.goodform.ticketSystemYn
          data.tWayBusiness.incomeUnitPrice = this.goodform.incomeUnitPrice
          data.tWayBusiness.incomeAmount = this.goodform.incomeAmount
          data.tWayBusiness.generalCarrier = this.goodform.generalCarrier
          data.tWayBusiness.generalTaxId = this.goodform.generalTaxId
          data.tWayBusiness.collectionType = this.goodform.collectionType
          data.tWayBusiness.payer = this.goodform.payer
          data.tWayBusiness.payerTaxId = this.goodform.payerTaxId
          data.tWayBusiness.payerCode = this.goodform.payerCode
          data.tWayBusiness.expenditurePattern = this.goodform.expenditurePattern
          data.tWayBusiness.freightPricingType = this.goodform.freightPricingType
          data.tWayBusiness.expenditurePatternName = this.goodform.expenditurePatternName
          data.tWayBusiness.freightPricingTypeName = this.goodform.freightPricingTypeName
          data.tWayBusiness.freightUnitPrice = this.goodform.freightUnitPrice
          data.tWayBusiness.freightAmount = this.goodform.freightAmount
          data.tWayBusiness.serviceRate = this.goodform.serviceRate
          data.tWayBusiness.serviceCharge = this.goodform.serviceCharge
          data.tWayBusiness.freightTaxRate = this.goodform.freightTaxRate
          data.tWayBusiness.onlineFreightFlag = this.goodform.onlineFreightFlag
          data.tWayBusiness.revenueSurcharge = this.goodform.revenueSurcharge
          data.tWayBusiness.disburseSurcharge = this.goodform.disburseSurcharge
          data.tWayBusiness.grossRevenue = this.goodform.grossRevenue
          data.tWayBusiness.freightRemark = this.goodform.freightRemark
          data.tWayBusiness.incomeRemark = this.goodform.incomeRemark
          let zhuangxieForm = new FormData()
          zhuangxieForm.append('params', JSON.stringify(data))

          let jiekouarr = []// 用于判断凭证接口是否走完

          let imgfile = new FormData()
          imgfile.append('params', JSON.stringify({
            wayNo: this.goodform.wayNo,
            type: 1,
            imageType: 1,
            wayBusinessId: this.wayBusinessId
          }))
          this.ZCimgList.forEach(item => {
            if (!item.id) {
              imgfile.append('files', item.raw)
            }
          })
          if (imgfile.get('files')) { // 走装车接口
            insertWayImg(imgfile).then(res => {
              jiekouarr.push(1)
              jiekou(jiekouarr)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            jiekouarr.push(1)
            jiekou(jiekouarr)
          }

          let imgfile1 = new FormData()
          imgfile1.append('params', JSON.stringify({
            wayNo: this.goodform.wayNo,
            type: 2,
            imageType: 1,
            wayBusinessId: this.wayBusinessId
          }))
          this.XCimgList.forEach(item => {
            if (!item.id) {
              imgfile1.append('files', item.raw)
            }
          })
          if (imgfile1.get('files')) { // 走卸车车接口
            insertWayImg(imgfile1).then(res => {
              jiekouarr.push(1)
              jiekou(jiekouarr)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            jiekouarr.push(1)
            jiekou(jiekouarr)
          }

          // 删除凭证
          if (this.delImgIds.length > 0) {
            delWayImg({
              wayNo: this.goodform.wayNo,
              ids: this.delImgIds.toString()
            }).then(res => {
              jiekouarr.push(1)
              jiekou(jiekouarr)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            jiekouarr.push(1)
            jiekou(jiekouarr)
          }
          let that = this
          // eslint-disable-next-line no-inner-declarations
          function jiekou (jiekouarr) {
            if (jiekouarr.length == 3) {
              signForWay(zhuangxieForm).then(res => {
                loading.close()
                that.$emit('update:qianshouWHFlag', false)
                that.$parent.searchFn()
              }).catch(error => {
                that.$message({
                  showClose: true,
                  message: error.message,
                  type: 'error',
                  onClose () {
                    loading.close()
                  }
                })
              })
            }
          }
        }
      })
    },
    // 运单状态改变
    wayStateChange (e) {
      if (e == 1) {
        this.$set(this.goodform, 'truckload', '')
        this.$set(this.goodform, 'actualLoadingTime', '')
        this.ZCimgList = []
        this.$set(this.goodform, 'unloadings', '')
        this.$set(this.goodform, 'actualUnloadingTime', '')
        this.XCimgList = []
        this.$set(this.goodform, 'receiptRequest', '')
        this.$set(this.goodform, 'signRemark', '')
        this.$set(this.goodform, 'actualSigningTime', '')
        this.$set(this.goodform, 'liquidatedAmount', '')
        this.QSimgList = []
      } else if (e == 2) {
        this.$set(this.goodform, 'unloadings', '')
        this.$set(this.goodform, 'actualUnloadingTime', '')
        this.XCimgList = []
        this.$set(this.goodform, 'receiptRequest', '')
        this.$set(this.goodform, 'signRemark', '')
        this.$set(this.goodform, 'actualSigningTime', '')
        this.$set(this.goodform, 'liquidatedAmount', '')
        this.QSimgList = []
      } else if (e == 3) {
        this.$set(this.goodform, 'receiptRequest', '')
        this.$set(this.goodform, 'signRemark', '')
        this.$set(this.goodform, 'actualSigningTime', '')
        this.$set(this.goodform, 'liquidatedAmount', '')
        this.QSimgList = []
      } else if (e == 4) {
        this.$set(this.goodform, 'receiptRequest', '正常签收')
      }
    },
    // 选择结算客户
    jiesuanChange () {
      let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
      this.goodform.payCustomerId = json[0].id
      this.goodform.payeeTaxId = json[0].customerTaxId
      this.goodform.payeeCode = json[0].tenantCode
      this.goodform.salesContract = ''
      this.goodform.periodDays = json[0].periodDays
      this.goodform.periodDaysType = json[0].periodDaysType
      if (json[0].businessUserCode) {
        this.ywyhFlag = true
        this.$set(this.goodform, 'businessUserId', json[0].businessUserCode)
        this.$set(this.goodform, 'businessUser', json[0].businessUserName)
      } else {
        this.ywyhFlag = false
        this.$set(this.goodform, 'businessUserId', null)
        this.$set(this.goodform, 'businessUser', null)
      }
    },
    xuanzeHT () {
      this.GLHTflag = true
    },
    delGoodFn () {
    },
    closeDialog () {
      this.$emit('update:qianshouWHFlag', false)
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
/deep/.remark .el-input .el-input__inner{
  width: 800px;
  height: 80px;
}
/deep/.el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 14px 0 !important;
}
.disabled /deep/.el-input__inner {
    background: #eff0f1;
}
.width1  /deep/.el-input__inner{
  width:100px;
}
.danweiBox{
  /deep/.el-input{
    width: auto;
  }
  /deep/.el-select{
    width: 60px;
    .el-input__inner{
    width: 60px;
  }
  }
}
.imgBox{
  margin: 0px 15px  10px;
}
/deep/.el-range-editor{
  width: 430px;
}
.boxSR /deep/.el-input__inner{
  width: 100px;
}
.imgBox{
  /deep/.el-image{
    width: 180px;
    height: 130px;
    margin: 6px;
  }
}
/deep/.el-form-item--mini .el-form-item__label{
  font-size: 12px;
}
/deep/.el-form-item--mini .el-form-item__content{
  font-size: 12px;
}
/deep/.el-table th>.cell{
  font-size: 12px;
}
</style>
